import React, { Component } from 'react';

import './ReferenceLists.css';

// Components
import ListTabs from './ListTabs';

// Lists
import GLobalEntityList from './Lists/GlobalEntityList/GlobalEntityList';
import EntityList from './Lists/EntityList/EntityList';
import EntityListContainer from '../containers/EntityListContainer';
import ModuleList from './Lists/ModuleList';
import AgentList from './Lists/AgentList';

class ReferenceLists extends Component {

  static defaultProps = {
    topicUpdateID : -1,
    isForInstance : false, // props로 랜더링 하지 않고 instance개념으로 사용할 떄 (컴포넌트 자체 랜더링)
    showTabs: {
      GLOBAL_ENTITY: true,
      TOPIC_ENTITY: undefined,
      MODULE: undefined,
      AGENT: undefined,
    },
    importEntity : () => {

    } , // 
    exportEntity : ( ) => {

    }
  }

  state = {
    tabType : null,
  }

  renderList = () => {
    const { tabType } = this.state;
    
    if (tabType) {
      switch (tabType) {
        case "GLOBAL_ENTITY":
        return (
          <GLobalEntityList
            disableTypes={[3]} />
        );
  
        case "ENTITY":
        return (
          <EntityListContainer
            /**
             * TODO Write Props from container
             */
            isForInstance={this.props.isForInstance}
            importEntity={this.props.importEntity}
            disableTypes={[3]}/>
        );
  
        case "MODULE":
        return (
          <ModuleList />
        );
  
        case "AGENT":
        return (
          <AgentList />
        );
  
        default:
        return (
          <div>
            <h3> 정의되어있지 않은 메뉴 타입 </h3>
          </div>
        );
      }
    }
    
    return ( // 아무 메뉴가 선택되지 않음
      <div>
        {/* <p> 메뉴가 선택되지 않았습니다. </p> */}
      </div>
    );
  }

  setTabType = (tabType) => {
    this.setState({
      tabType : tabType,
    })
  }

  render() {

    const { renderList } = this;
    const { setTabType } = this;

    const renderedList = renderList();

    return (
      <div className="reference-lists">
        <div className="list-wrapper">
          <div className="list-tab-area">
            <div className="tab-wrapper">
              <div className="row">
                <ListTabs setTabType={setTabType}
                  showTabs={this.props.showTabs}
                  isForInstance={this.props.isForInstance} />
              </div>
            </div>
          </div>
          <div className="list-active-area">
            {renderedList}
          </div>
        </div>
      </div>
    );
  }
}

export default ReferenceLists;